/** @format */

import React from 'react';

import {IconButton, TextLink} from '@sttark/design-system';

export default function GoBack({label, onClick}) {
    return (
        <TextLink secondary onClick={onClick}>
            <IconButton secondary icon="arrowleft" /> {label}
        </TextLink>
    );
}
